import { Box, Button, Typography, styled } from '@mui/material';
import { SOFT_BORDER_DARK, SOFT_BORDER_LIGHT } from 'src/helpers/uiTokens';

export const DoneButton = styled(Button)(({ theme }) => ({
  width: '100%',
  padding: '13px 16px',
  borderRadius: '12px',
  textTransform: 'none',
  fontSize: 14,
  fontWeight: 700,
  color: '#fff',
  backgroundColor: theme.palette.primary.main,
  '&:hover': { backgroundColor: theme.palette.primary.dark },
}));

/** Green badge behind the success tick. */

/** Green badge behind the success tick. */
export const SuccessBadge = styled(Box)({
  display: 'grid',
  placeItems: 'center',
  width: 56,
  height: 56,
  borderRadius: '99px',
  color: '#fff',
  background: 'linear-gradient(150deg, #2eb877, #137a44)',
  boxShadow: '0 10px 22px -10px rgba(19,122,68,.8)',
});

/** One of the two after-purchase balance tiles. */

/** One of the two after-purchase balance tiles. */
export const StatTile = styled(Box)(({ theme }) => ({
  flex: 1,
  border: `1px solid ${SOFT_BORDER_LIGHT}`,
  borderRadius: '12px',
  padding: '10px 12px',
  display: 'grid',
  gap: '4px',
  justifyItems: 'center',
  backgroundColor: '#fbfcfe',
  ...theme.applyStyles('dark', {
    borderColor: SOFT_BORDER_DARK,
    backgroundColor: theme.palette.action.hover,
  }),
}));

export const TileLabel = styled(Typography)(({ theme }) => ({
  fontSize: 10,
  fontWeight: 700,
  letterSpacing: '.6px',
  textTransform: 'uppercase',
  color: theme.palette.text.secondary,
}));
